// Sorts `items` to follow `orderKeys`. Items not in `orderKeys` go at the end, unchanged.
export function applyOrder(items, orderKeys, keyOf = (item) => item) {
	const ordered = [...new Set(orderKeys || [])]
		.map((key) => items.find((item) => keyOf(item) === key))
		.filter(Boolean);
	const missing = items.filter((item) => !ordered.includes(item));
	return [...ordered, ...missing];
}
